<template>
  <b-card no-body class="shadow-sm border-0" style="background-color: white !important;">
    <!-- Header Card & Search Filter -->

    <!-- Table Body -->
    <b-card-body class="p-0" >
      <div class="custom-table-container">
        <div class="table-scroll">
          <table class="pure-custom-table">
            <thead>
              <tr>
                <th>Subjek Hukum</th>
                <th>Provinsi</th>
                <th>Detail Kegiatan</th>
                <th class="text-center">Luas</th>
                <th>Jenis</th>
                <th>Status Permohonan</th>
                <th class="text-center">Aksi</th>
              </tr>
            </thead>
            <tbody>
              <!-- Spinner / State Loading -->
              <tr v-if="isLoading">
                <td colspan="7" class="text-center py-4">
                  <div class="loading-state">
                    <span class="spinner"></span>
                    <span>Memuat data...</span>
                  </div>
                </td>
              </tr>

              <!-- Empty State -->
              <tr v-else-if="!dataPermohonan || dataPermohonan.length === 0">
                <td colspan="7" class="text-center py-4 text-muted">
                  Tidak ada data permohonan.
                </td>
              </tr>

              <!-- Data Rows (Menggunakan paginatedData agar ter-paging dengan benar) -->
              <tr v-else v-for="(item, index) in paginatedData" :key="index">
                <td class="fw-bold text-dark">
                  {{ item.tipe_pemohon === 'Pemerintah' || item.tipe_pemohon === 'Swasta' ? item.instansi_pemohon : item.nama_pemohon }}
                </td>
                <td>{{ item.provinsi || '-' }}</td>
                <td>
                  <div class="cell-detail-kegiatan">
                    {{ item.jenis_kegiatan }}
                  </div>
                </td>
                <td class="text-center">{{ item.luas }} Ha</td>
                <td>
                  <span 
                    class="custom-badge" 
                    :class="item.jenis === 'berusaha' ? 'badge-berusaha' : 'badge-nonberusaha'"
                  >
                    {{ item.jenis }}
                  </span>
                </td>
                <td>
                  <StatusBadge :status="item.keterangan_status" />
                </td>
                <td class="text-center">
                  <button 
                    type="button" 
                    class="btn-detail" 
                    @click="$emit('on-detail', item)"
                  >
                    <i class="fa fa-eye me-1"></i> Detail
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card-body>

    <!-- Footer & Pagination -->
    <b-card-footer class="bg-white py-3 border-0" v-if="totalRows > 0">
      <div class="row align-items-center">
        <div class="col-md-6 text-muted small mb-2 mb-md-0">
          Menampilkan {{ startItem }} - {{ endItem }} dari {{ totalRows }} data
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            size="sm"
            class="mb-0"
          ></b-pagination>
        </div>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import StatusBadge from "./component/StatusBadge.vue";

export default {
  name: "TableDashboard",
  components: {
    StatusBadge
  },
  props: {
    dataPermohonan: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filter: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      fields: [
        { key: "subjek_hukum", label: "Subjek Hukum", sortable: true },
        { key: "provinsi", label: "Provinsi", sortable: true },
        { key: "detail_kegiatan", label: "Detail Kegiatan" },
        { key: "luas", label: "Luas", sortable: true, class: "text-end" },
        { key: "status_permohonan", label: "Status Permohonan", sortable: true, class: "text-center" },
        { key: "jenis", label: "Jenis Permohonan", sortable: true, class: "text-center" },
        { key: "aksi", label: "Aksi", class: "text-center" }
      ]
    };
  },
  watch: {
    dataPermohonan: {
      immediate: true,
      handler(val) {
        this.totalRows = val ? val.length : 0;
        this.currentPage = 1; // Reset ke halaman 1 saat data berubah
      }
    }
  },
  computed: {
    // Memotong data sesuai halaman dan jumlah perPage
    paginatedData() {
      if (!this.dataPermohonan) return [];
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.dataPermohonan.slice(start, end);
    },
    startItem() {
      if (this.totalRows === 0) return 0;
      return (this.currentPage - 1) * this.perPage + 1;
    },
    endItem() {
      const end = this.currentPage * this.perPage;
      return end > this.totalRows ? this.totalRows : end;
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
/* Container Pembungkus Transparan */
.custom-table-container {
  width: 100%;
  background-color: transparent !important;
}

.table-scroll {
  overflow-x: auto;
  border-radius: 8px;
}

/* Tabel Utama */
.pure-custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
  text-align: left;

  background-color: transparent !important;
}

/* Header Tabel Solid & Kontras */
.pure-custom-table thead {
  background-color: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0;
}

.pure-custom-table th {
  padding: 12px 14px;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
  letter-spacing: 0.1px;
  text-transform: capitalize !important;
}

/* Baris dan Sel Data Transparan (Clear) */
.pure-custom-table tbody tr {
  background-color: transparent !important;
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.15s ease;
}

.pure-custom-table tbody td {
  padding: 12px 14px;
  color: #1e293b;
  background-color: transparent !important;
}

/* Hover Ringan pada Baris Data */
.pure-custom-table tbody tr:hover {
  background-color: rgba(241, 245, 249, 0.5) !important;
}

/* Utilitas Kelas internal */
.cell-detail-kegiatan {
  max-width: 300px;
  white-space: normal;
  word-break: break-word;
}

.text-center {
  text-align: center;
}

.fw-bold {
  font-weight: 600;
}

.text-dark {
  color: #0f172a;
}

.text-muted {
  color: #64748b;
}

/* Custom Badges */
.custom-badge {
  display: inline-block;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
}

.badge-berusaha {
  background-color: #edf6fd;
  color: #0879df;
}

.badge-nonberusaha {
  background-color: #ecfdf5;
  color: #047857;
}

/* Tombol Detail */
.btn-detail {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  border-radius: 6px;
  color: #182d70;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-detail:hover {
  background-color: #f1f5f9;
  border-color: #182d70;
}

/* Spinner sederhana jika loading */
.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #0879df;
  font-weight: 500;
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #edf6fd;
  border-top-color: #0879df;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>